export const NoDuty = () => import("./NoDuty.vue");
export const DutyList = () => import("./DutyList.vue");
export const ToDayDuty = () => import("./ToDayDuty.vue");
export const Dashboard = () => import("./Dashboard.vue");
export const UserDutyList = () => import("./UserDutyList.vue");
export const ParadeEscape = () => import("./ParadeEscape.vue");
export const AvailForDuty = () => import("./AvailForDuty.vue");
export const LateEarlyJoin = () => import("./LateEarlyJoin.vue");
export const UserAbsentList = () => import("./UserAbsentList.vue");
export const DutyPostStatus = () => import("./DutyPostStatus.vue");
export const UserDutyDetails = () => import("./UserDutyDetails.vue");
export const UserMonthlyDuty = () => import("./UserMonthlyDuty.vue");
export const UserAbsentDetails = () => import("./UserAbsentDetails.vue");
export const CadreDutyPostUsers = () => import("./CadreDutyPostUsers.vue");
export const ParadeEscapeUpdate = () => import("./ParadeEscapeUpdate.vue");
